import { Box } from "@material-ui/core";

import { Risk } from "./risk";
import { Traction } from "./traction";
import { Profitability } from "./profitability";

export const TenantProfile = () => {
  return (
    <Box>
      <Box style={{ marginBottom: 24 }}>
        <Profitability />
      </Box>
      <Box style={{ marginBottom: 24 }}>
        <Risk />
      </Box>
      <Traction />
    </Box>
  );
};
